var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrverseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 705.34 154.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 491.75,
    y1: 106.97,
    x2: -127.07,
    y2: 73.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d08fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4c0afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4811fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#421efc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3930fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2e48fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2165fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1187fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#00acff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 415.8,
    y1: 98.26,
    x2: -80.68,
    y2: 71.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d08fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4c0afc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4811fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#421efc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3930fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2e48fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2165fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1187fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00acff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 516.32,
    y1: 99.01,
    x2: 16.59,
    y2: 71.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 603.68,
    y1: 97.95,
    x2: 162.59,
    y2: 73.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 704.57,
    y1: 98.26,
    x2: 208.08,
    y2: 71.09,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m651.53,31.04c-1.46.73-3.03,1.1-4.7,1.1-3.14,0-5.7-3.08-7.68-9.25-.84-2.51-1.25-4.65-1.25-6.43s.37-3.14,1.1-4.08c.94-1.36,2.82-2.46,5.64-3.29l25.87-8c2.72-.73,4.28-1.1,4.7-1.1,3.14,0,5.64,3.08,7.52,9.25.84,2.51,1.25,4.62,1.25,6.35s-.37,3.06-1.1,4c-.94,1.36-2.82,2.46-5.64,3.29l-25.71,8.15Z",
    fill: "#00abff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m94.06,40.46c-.94-.73-2.3-1.36-4.08-1.88-1.78-.52-4.18-.78-7.21-.78s-5.54.31-7.52.94c-1.99.63-3.4,1.72-4.23,3.29-.84,1.57-1.33,2.95-1.49,4.15s-.23,3-.23,5.41v32.14H27.75v-31.98c0-3.66-.26-6.38-.78-8.15-1.36-3.87-5.7-5.8-13.01-5.8-6.69,0-10.76,1.41-12.23,4.23-.84,1.57-1.33,2.95-1.49,4.15-.16,1.2-.24,3-.24,5.41v87.01c0,3.66.31,6.38.94,8.15,1.25,3.87,5.54,5.8,12.85,5.8,6.69,0,10.76-1.41,12.23-4.23.84-1.57,1.33-2.95,1.49-4.15.16-1.2.24-3,.24-5.41v-31.98h41.54v31.82c0,3.66.31,6.38.94,8.15,1.25,3.87,5.54,5.8,12.85,5.8,6.69,0,10.76-1.41,12.23-4.23.84-1.57,1.33-2.95,1.49-4.15.16-1.2.24-3,.24-5.41V51.74c0-3.66-.26-6.38-.78-8.15-.52-1.36-1.25-2.4-2.19-3.14Z",
    fill: "#00abff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m197.52,133.26c-4.81-10.87-8.36-19.07-10.66-24.61,7.84-7.63,11.76-17.35,11.76-29.16,0-6.79-1.36-12.96-4.08-18.5-2.72-5.54-6.17-9.93-10.35-13.17-8.67-6.69-17.61-10.03-26.81-10.03h-33.86c-6.69,0-10.76,1.41-12.23,4.23-.84,1.57-1.33,2.95-1.49,4.15-.16,1.2-.24,3-.24,5.41v87.01c0,3.66.31,6.38.94,8.15,1.25,3.87,5.54,5.8,12.85,5.8,6.69,0,10.76-1.41,12.23-4.23.84-1.57,1.33-2.95,1.49-4.15.16-1.2.24-3,.24-5.41v-17.71h19.75l4.86-.31c7.11,16.93,11.18,26.39,12.23,28.37.63,1.05,1.59,2.06,2.9,3.06,1.31.99,2.98,1.49,5.02,1.49s4.73-.73,8.07-2.19c6.48-2.72,9.72-6.06,9.72-10.03,0-1.67-.78-4.39-2.35-8.15Zm-31.04-43.42c-3.03,2.3-6.06,3.45-9.09,3.45h-20.07v-27.75h19.75c3.24,0,6.38,1.18,9.41,3.53,3.03,2.35,4.55,5.83,4.55,10.42s-1.52,8.05-4.55,10.35Z",
    fill: "#00abff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m308.88,40.14c-3.45-1.78-6.53-2.67-9.25-2.67s-5.02,1.41-6.9,4.23c-.63,1.15-1.36,2.72-2.19,4.7l-31.35,68.66c-.42-.84-2.27-4.83-5.57-11.99-3.29-7.16-6.79-14.76-10.5-22.81-3.71-8.05-7.19-15.65-10.42-22.81-3.24-7.16-5.25-11.5-6.04-13.01-.78-1.52-1.65-2.9-2.59-4.15-.84-1.05-1.72-1.78-2.67-2.19-.94-.42-2.33-.63-4.15-.63s-4.47.89-7.92,2.67c-6.17,3.03-9.25,6.38-9.25,10.03,0,1.67.78,4.18,2.35,7.52l43.27,87.79c1.15,2.3,2.9,4.15,5.25,5.57,2.35,1.41,4.83,2.12,7.45,2.12h1.57c2.51,0,4.94-.71,7.29-2.12,2.35-1.41,4.1-3.27,5.25-5.57l43.27-87.79c1.57-3.34,2.35-5.85,2.35-7.52,0-3.66-3.08-7-9.25-10.03Z",
    fill: "url(#linear-gradient)",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m402.62,66.17c3.66,0,6.38-.31,8.15-.94,3.87-1.25,5.8-5.54,5.8-12.85,0-6.69-1.41-10.76-4.23-12.23-1.57-.84-2.95-1.33-4.15-1.49s-3-.24-5.41-.24h-61.77c-5.54,0-9.3.97-11.29,2.9-1.99,1.93-2.98,5.57-2.98,10.9v87.16c0,3.66.31,6.32.94,8,1.25,3.97,5.54,5.96,12.85,5.96h62.08c3.66,0,6.38-.31,8.15-.94,3.87-1.25,5.8-5.54,5.8-12.85,0-6.69-1.41-10.76-4.23-12.23-1.57-.84-2.95-1.33-4.15-1.49-1.2-.16-3-.23-5.41-.23h-48.28v-15.83h30.73c3.66,0,6.38-.31,8.15-.94,3.97-1.25,5.96-5.54,5.96-12.85,0-6.69-1.41-10.76-4.23-12.23-1.57-.84-2.95-1.33-4.15-1.49-1.2-.16-3-.24-5.41-.24h-31.04v-15.83h48.13Z",
    fill: "url(#linear-gradient-2)",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m504.05,109.28c7.84-7.63,11.76-17.35,11.76-29.16,0-6.79-1.36-12.96-4.08-18.5-2.72-5.54-6.17-9.93-10.35-13.17-8.67-6.69-17.61-10.03-26.81-10.03h-33.86c-6.69,0-10.76,1.41-12.23,4.23-.84,1.57-1.33,2.95-1.49,4.15-.16,1.2-.24,3-.24,5.41v87.01c0,3.66.31,6.38.94,8.15,1.25,3.87,5.54,5.8,12.85,5.8,6.69,0,10.76-1.41,12.23-4.23.84-1.57,1.33-2.95,1.49-4.15.16-1.2.24-3,.24-5.41v-17.71h19.75l4.86-.31c7.11,16.93,11.18,26.39,12.23,28.37.63,1.05,1.59,2.06,2.9,3.06,1.31.99,2.98,1.49,5.02,1.49s4.73-.73,8.07-2.19c6.48-2.72,9.72-6.06,9.72-10.03,0-1.67-.78-4.39-2.35-8.15-4.81-10.87-8.36-19.07-10.66-24.61Zm-20.38-18.81c-3.03,2.3-6.06,3.45-9.09,3.45h-20.07v-27.75h19.75c3.24,0,6.38,1.18,9.41,3.53,3.03,2.35,4.55,5.83,4.55,10.42s-1.52,8.05-4.55,10.35Z",
    fill: "url(#linear-gradient-3)",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m591.37,89.68c-3.97-1.88-8.31-3.47-13.01-4.78-4.7-1.31-9.04-2.27-13.01-2.9-3.97-.63-7.29-1.83-9.95-3.61-2.67-1.78-4-4.1-4-6.98s1.12-5.12,3.37-6.74c2.25-1.62,5.07-2.43,8.47-2.43s6.19.68,8.39,2.04c.73.52,1.54,1.2,2.43,2.04.89.84,1.49,1.36,1.8,1.57,3.24,2.09,5.96,3.14,8.15,3.14,3.76,0,7.42-2.61,10.97-7.84,2.51-3.66,3.76-6.53,3.76-8.62s-1.62-4.65-4.86-7.68l-3.92-2.98c-1.99-1.67-5.57-3.32-10.74-4.94-5.17-1.62-10.9-2.43-17.17-2.43-11.81,0-21.14,3.42-27.98,10.27s-10.27,14.87-10.27,24.06c0,6.69,1.33,12.41,4,17.17,2.66,4.76,5.98,8.23,9.95,10.42,3.97,2.19,8.26,4.1,12.85,5.72,4.6,1.62,8.88,2.8,12.85,3.53,3.97.73,7.29,1.91,9.95,3.53s4,3.63,4,6.04c0,7.94-4.86,11.91-14.58,11.91-2.3,0-4.81-.81-7.52-2.43-2.72-1.62-4.81-3.32-6.27-5.09-5.23-5.23-9.3-7.84-12.23-7.84s-5.7,1.25-8.31,3.76c-4.49,4.39-6.74,7.92-6.74,10.58s1.36,5.67,4.08,9.01l1.41,1.72c2.19,3.14,6.06,6.38,11.6,9.72,2.72,1.78,6.27,3.27,10.66,4.47,4.39,1.2,9.04,1.8,13.95,1.8,9.62,0,18.66-2.77,27.12-8.31,4.39-2.82,7.94-6.82,10.66-11.99,2.72-5.17,4.08-11.16,4.08-17.95s-1.33-12.52-4-17.17c-2.66-4.65-5.98-7.92-9.95-9.8Z",
    fill: "url(#linear-gradient-4)",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m701.11,127.3c-1.57-.84-2.95-1.33-4.15-1.49-1.2-.16-3-.23-5.41-.23h-48.28v-15.83h30.73c3.66,0,6.38-.31,8.15-.94,3.97-1.25,5.96-5.54,5.96-12.85,0-6.69-1.41-10.76-4.23-12.23-1.57-.84-2.95-1.33-4.15-1.49-1.2-.16-3-.24-5.41-.24h-31.04v-15.83h48.13c3.66,0,6.38-.31,8.15-.94,3.87-1.25,5.8-5.54,5.8-12.85,0-6.69-1.41-10.76-4.23-12.23-1.57-.84-2.95-1.33-4.15-1.49s-3-.24-5.41-.24h-61.77c-5.54,0-9.3.97-11.29,2.9-1.99,1.93-2.98,5.57-2.98,10.9v87.16c0,3.66.31,6.32.94,8,1.25,3.97,5.54,5.96,12.85,5.96h62.08c3.66,0,6.38-.31,8.15-.94,3.87-1.25,5.8-5.54,5.8-12.85,0-6.69-1.41-10.76-4.23-12.23Z",
    fill: "url(#linear-gradient-5)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrverseLogo);
export default __webpack_public_path__ + "static/media/HRVERSE_logo.4d8ad5a027f28b8ed989e0a0112bf20d.svg";
export { ForwardRef as ReactComponent };